import React, { PropsWithChildren } from 'react'
import TransferValueMessageModalProvider from './TransferValueMessageModalProvider'

const ValueMessageActionsProvider = ({ children }: PropsWithChildren<{}>) => {
    return <TransferValueMessageModalProvider>{children}</TransferValueMessageModalProvider>
}

export default ValueMessageActionsProvider
